"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ChecklistSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var ChecklistSVG = function ChecklistSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M26 2H6a2 2 0 00-2 2v24a2 2 0 002 2h20a2 2 0 002-2V4a2 2 0 00-2-2zM13 25h-2a1 1 0 010-2h2a1 1 0 010 2zm1.73-8.83l-2.86 3a.87.87 0 01-1.3 0l-1.3-1.38a1 1 0 010-1.38.88.88 0 011.3 0l.65.69 2.21-2.36a.9.9 0 011.3 0 1 1 0 010 1.43zm0-7l-2.86 3a.87.87 0 01-1.3 0l-1.3-1.38a1 1 0 010-1.38.88.88 0 011.3 0l.65.69 2.21-2.36a.9.9 0 011.3 0 1 1 0 010 1.43zM22 25h-4a1 1 0 010-2h4a1 1 0 010 2zm0-6h-4a1 1 0 010-2h4a1 1 0 010 2zm0-7h-4a1 1 0 010-2h4a1 1 0 010 2z"
  }));
};
exports.ChecklistSVG = ChecklistSVG;
ChecklistSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ChecklistSVG);
exports.default = _default;